import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import axios from 'axios';
import { gsap } from "../../gsap/gsap.min.js";
import { ScrollTrigger } from "../../gsap/ScrollTrigger.min.js";
import { getFirstImage } from '../helpers/helperFunctions.js';

gsap.registerPlugin(ScrollTrigger);

function WorksGrid({ id }) {
	const pageUrl = process.env.REACT_APP_API_PAGE_URL;
	const [page, setPage] = useState(null);
	const [pageTitle, setPageTitle] = useState(null);
	const [pageArticles, setPageArticles] = useState([]);
	const [isAccordionOpen, setAccordionOpen] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			axios.get(`${pageUrl}${id}`)
				.then(res => {
					const response = res.data;
					setPage(response);
					/*console.log("WorkGrid Page", response);*/
				});
		};
		fetchData();
	}, [id]);

	useEffect(() => {
		if (page != null) {
			setPageTitle(page.title);

			if (page.articles != null) {
				page.articles.items.forEach((item) => {
					const friendlyName = item.friendlyName.substring(item.friendlyName.lastIndexOf("/") + 1);
					item.friendlyName = friendlyName;
				});
				setPageArticles(page.articles.items);
				/*console.log("WorkGrid PageArticles", page.articles.items);*/
			}
		}
	}, [page]);

	useEffect(() => {
		const animatedEls = document.querySelectorAll('.fadeInUp-el');
		animatedEls.forEach((el) => {
			gsap.fromTo(el,
				{
					opacity: 0,
					y: 50,
				},
				{
					opacity: 1,
					y: 0,
					duration: 2,
					ease: "power2.out",
					scrollTrigger: {
						trigger: el,
						start: "top-=100px 80%",
						end: "bottom 20%",
						markers: false,
					},
				}
			);
		});

		const animatedEls2 = document.querySelectorAll('.fadeInLeft-el');
		animatedEls2.forEach((el) => {
			gsap.fromTo(el,
				{
					opacity: 0,
					x: -50,
				},
				{
					opacity: 1,
					x: 0,
					duration: 2,
					ease: "power2.out",
					scrollTrigger: {
						trigger: el,
						start: "top-=100px 80%",
						end: "bottom 20%",
						markers: false,
					},
				}
			);
		});

		const animatedEls3 = document.querySelectorAll('.fadeInRight-el');
		animatedEls3.forEach((el) => {
			gsap.fromTo(el,
				{
					opacity: 0,
					x: 50,
				},
				{
					opacity: 1,
					x: 0,
					duration: 2,
					ease: "power2.out",
					scrollTrigger: {
						trigger: el,
						start: "top-=100px 80%",
						end: "bottom 20%",
						markers: false,
					},
				}
			);
		});
	}, [pageTitle]);


	const toggleAccordion = () => {
		const accordion = document.querySelector('.six-more-articles');
		const buttonRow = document.querySelector('.load-more-articles-wrapper');

		// fadeOut sulla row del pulsante
		//gsap.to(buttonRow, {
		//	opacity: 0,
		//	duration: 0.3,
		//	onComplete: () => {
		//		// Nascondi la row del pulsante dopo il fadeOut
		//		gsap.set(buttonRow, { display: 'none' });
		//		if (isAccordionOpen) {
		//			gsap.to(accordion, {
		//				height: 0,
		//				opacity: 0,
		//				duration: 0.5,
		//				ease: 'power2.inOut',
		//			});
		//		} else {
		//			gsap.set(accordion, { height: 'auto' });
		//			const height = accordion.offsetHeight;
		//			gsap.fromTo(accordion, {
		//				height: 0,
		//				opacity: 0,
		//			}, {
		//				height: height,
		//				opacity: 1,
		//				duration: 0.5,
		//				ease: 'power2.inOut',
		//			});
		//		}
		//		setAccordionOpen(!isAccordionOpen);
		//	}
		//});

		if (isAccordionOpen) {
			gsap.to(accordion, {
				height: 0,
				opacity: 0,
				duration: 0.5,
				ease: 'power2.inOut',
				onComplete: () => {
					setAccordionOpen(!isAccordionOpen);
				}
			});
		} else {
			gsap.set(accordion, { height: 'auto' });
			const height = accordion.offsetHeight;
			gsap.fromTo(accordion, {
				height: 0,
				opacity: 0,
			}, {
				height: height,
				opacity: 1,
				duration: 0.5,
				ease: 'power2.inOut',
				onComplete: () => {
					setAccordionOpen(!isAccordionOpen);
				}
			});
		}
	};



	return (
		<>
			{pageTitle != null && (
				<div className={`bg-white pt-4 pb-${isAccordionOpen ? "0" : "0"}`} id="works-section">
					<div className='container-lg py-5'>
						<div className='row text-wrapper'>
							<div className="col-12">
								<h1 className="fs-2 text-uppercase fw-900 text-dark fadeInUp-el">
									{pageTitle}
								</h1>
							</div>
						</div>
					</div>
					<div className='container-fluid'>
						<div className="row">
							{pageArticles != null && pageArticles.length > 0 && pageArticles.slice(0, 6).map((article, index) => (
								<div key={index}
					 				className={`col-12 ${(index === 0 || index === 4) ? "col-md-5" : (index === 1 || index === 5) ? "col-md-7" : "col-md-6"} pb-3 ${index % 2 !== 0 ? "ps-md-2 ps-0 pe-0 fadeInRight-el" : "ps-0 pe-0 pe-md-2 fadeInLeft-el"}`}>
									<Link to={`/works/${article.friendlyName}`} className="d-flex case-wrapper hover-cursor py-4 image-bg-item"
										style={{ "--image-url": `url('${getFirstImage(article, "urlFullHD")}')` }}>
										<h2 className="fw-700 mb-2 text-white pb-2" style={{ lineHeight: '3rem' }}>{article.title}</h2>
										{article.author && (
											<p className="fs-5 serif mb-0 text-white text-lowercase lh-sm">{article.author}</p>
										)}
									</Link>
								</div>
							))}
						</div>
						{pageArticles != null && pageArticles.length > 6 && (
							<>
								<div className="row six-more-articles" style={{ height: 0, overflow: 'hidden' }}>
									{pageArticles.slice(6, 30).map((article, index) => (
										<div key={index}
											className={`col-12 ${(index === 1 || index === 5) ? "col-md-5" : (index === 0 || index === 4) ? "col-md-7" : "col-md-6"} pb-3 ${index % 2 !== 0 ? "ps-md-2 ps-0 pe-0 fadeInRight-el" : "ps-0 pe-0 pe-md-2 fadeInLeft-el"}`}>
											<Link to={`/works/${article.friendlyName}`} className="d-flex case-wrapper hover-cursor py-4 image-bg-item"
												style={{ "--image-url": `url('${getFirstImage(article, "urlFullHD")}')` }}>
												<h2 className="fw-700 mb-2 text-white pb-2" style={{ lineHeight: '3rem' }}>{article.title}</h2>
												{article.author && (
													<p className="fs-5 serif mb-0 text-white text-lowercase lh-sm">{article.author}</p>
												)}
											</Link>

										</div>
									))}
								</div>
								<div className="row">
									<div className="col-12 text-center load-more-articles-wrapper">
										<button className="no-decoration load-more-articles text-black" onClick={toggleAccordion}>
											<span style={{ transform: `${isAccordionOpen ? "rotate(45deg) translateX(11px)" : "rotate(0deg) translateX(0px)"}` }} className="plus-custom-icon d-block text-black">+</span> 
										</button>
									</div>
								</div>
							</>
						)}

					</div>
				</div>
			)}
		</>
	);
}

export default WorksGrid;
